import React, { useState } from 'react'
import "./SalesInvoice.scss"
import { FaCheck } from "react-icons/fa";
import { PiUpload } from "react-icons/pi";
import { Link } from 'react-router-dom';
import { FaFileAlt } from "react-icons/fa";
import { PiShareFatLight } from "react-icons/pi";
import { BiSolidPrinter } from "react-icons/bi";

export default function SalesInvoice() {
      const [activeRow, setActiveRow] = useState(null);
      const [open, setOpen] = useState(null);
        const toggleDetails = (index) => {
    setActiveRow(activeRow === index ? null : index);
  };
      const [orders] = useState([
        {
          id: 'INV-0012',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
        
        {
          id: 'INV-0012',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
            {
          id: 'INV-0012',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
            {
          id: 'INV-0012',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
            {
          id: 'INV-0012',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
            {
          id: 'INV-0012',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
            {
          id: 'INV-0012',
          client: 'Osama alabyaare',
          product: 'Social media',
          date: '12/12/23',
          time: '12:00 PM',
          amount: 'EGP 241.00',
          status: 'New',
        },
      ]);
  return (
    <div className='p-3'>
             <div className="headerr">
  <div className="stock-filters">
    <button className="stock-filter actives">24 Hour</button>
    <button className="stock-filter">7 Days</button>
    <button className="stock-filter">30 Days</button>
    <button className="stock-filter">12 Months</button>
  </div>

  <div className="search-wrapperr">
    <input
      type="text"
      placeholder="Search by order id"
      className="stock-search"
    />
    <i className="fa-solid fa-magnifying-glass search-icon"></i>
  </div>

  <div className="stock-header">
    <input type="date" placeholder="select dates" />
    <div className="stock-actions">
      <button className="stock-btn blue">Filters</button>
      <button className="stock-btn">Export</button>
    </div>
  </div>
</div>
 


          <div className="orders-table-wrapper">
              <table className="orders-table">
                <thead>
                  <tr>
                    <th>Invoice No</th>
                    <th>Client Name</th>
                    <th>Date</th>
                    <th> time</th>
                    <th>Amount</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order, index) => (
                    <React.Fragment key={index}>
                      <tr>
                    
<td className="order-id" style={{
  color: "black",
  fontWeight: "bold",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
  gap: "5px",
}}>
  <FaFileAlt style={{ color: "#898989", fontSize: "14px" }} />
  {order.id}
</td>

                        <td style={{  color:"#666666"}}>{order.client}</td>
                        <td style={{color:"#999999"}}>{order.date}</td>
                        <td  style={{color:"#999999"}}>{order.time}</td>
                        <td style={{color:"#999999"}}>{order.amount}</td>
                       
                        <td>
                          <span
                            className="order-details"
                            onClick={() => toggleDetails(index)}
                          >
                            ...
                          </span>
                        </td>
                      </tr>
      
                   {activeRow === index && (
       <>
      
          <tr className="details-row headers-row">
            <td colSpan="9">
              <div className="order-details-box " style={{backgroundColor:"#f7f9fb"}}>
                <h3 className="section "
                 style={{
                  color:"#999999"
                }}>CLIENT NAME</h3>
                <h3 className="section"   style={{
                  color:"#999999"
                }}>PHONE</h3>
      
      
                <h3 className="section"   style={{
                  color:"#999999"
                }}>EMAIL
                </h3>
                <h3 className="section"   style={{
                  color:"#999999"
                }}>COUNTRY</h3>
      
                <h3 className="section"   style={{
                  color:"#999999"
                }}>DATE</h3>
      
                <h3 className="section"   style={{
                  color:"#999999"
                }}>Time</h3>
      
                <h3 className="section"  style={{
                  color:"#999999"
                }}></h3>
              </div>
            </td>
          </tr>
      
          
          <tr className="details-row values-row">
            <td colSpan="9">
              <div className="order-details-box values" style={{backgroundColor:"#f7f9fb"}}>
                <h3 className="section">Osama Ali alabyaare</h3>
                <h3 className="section">+20 1012345678</h3>
                <h3 className="section">osama@email.com</h3>
                <h3 className="section">Egypt</h3>
                <h3 className="section">12/12/23</h3>
                <h3 className="section">12:00 PM</h3>
                <div   className="product-header"
    >
      
      
      
                </div>
              </div>
            </td>
          </tr>
        <>
      
      
      {/* ////////////////////// */}

      
            
          <tr className="details-row headers-row">
            <td colSpan="9">
              <div className="order-details-box " style={{backgroundColor:"white"}}>
                    <h3 className="section"    style={{
                  color:"#999999"
                }}>ORDER TYPE</h3>
                <h3 className="section"    style={{
                  color:"#999999"
                }}>CATEGORY</h3>
                <h3 className="section"    style={{
                  color:"#999999"
                }}>SKU</h3>
                <h3 className="section"    style={{
                  color:"#999999"
                }}>DURATION</h3>
                <h3 className="section"    style={{
                  color:"#999999"
                }}>START</h3>
                <h3 className="section"    style={{
                  color:"#999999"
                }}>ENDS</h3>
                <h3 className="section"    style={{
                  color:"#999999"
                }}>DAYS</h3>
              </div>
            </td>
          </tr>
      
          <tr className="details-row values-row">
            <td colSpan="9">
              <div className="order-details-box values">
                <h3 className="section">Service</h3>
                <h3 className="section">Social media</h3>
                <h3 className="section">#6580</h3>
                <h3 className="section">1 month</h3>
                <h3 className="section">24 may 2025</h3>
                <h3 className="section">24 may 2025</h3>
                <h3 className="section">30</h3>
       
              </div>
            </td>
          </tr>
            <tr className="details-row values-row">
            <td colSpan="9">
              <div className="order-details-box values">
                <h3 className="section">Service</h3>
                <h3 className="section">Social media</h3>
                <h3 className="section">#6580</h3>
                <h3 className="section">1 month</h3>
                <h3 className="section">24 may 2025</h3>
                <h3 className="section">24 may 2025</h3>
                <h3 className="section">30</h3>
       
              </div>
            </td>
          </tr>
            <tr className="details-row values-row">
            <td colSpan="9">
              <div className="order-details-box values">
                <h3 className="section">Service</h3>
                <h3 className="section">Social media</h3>
                <h3 className="section">#6580</h3>
                <h3 className="section">1 month</h3>
                <h3 className="section">24 may 2025</h3>
                <h3 className="section">24 may 2025</h3>
                <h3 className="section">30</h3>
       
              </div>
            </td>
          </tr>
      {/* //////////////////////////////////// */}
      
       <tr className="details-row headers-row">
            <td colSpan="9">
              <div className="order-details-box " style={{backgroundColor:"#f7f9fb"}}>
                <h3 className="section "
                 style={{
                  color:"#999999"
                }}>ORDER NO </h3>
                <h3 className="section"   style={{
                  color:"#999999"
                }}>TOTAL DUE</h3>
      
      
                <h3 className="section"   style={{
                  color:"#999999"
                }}>PAYMENT METHOD
                </h3>
                <h3 className="section"   style={{
                  color:"#999999"
                }}>ACCOUNT NO</h3>
      
                <h3 className="section"   style={{
                  color:"#999999"
                }}>DUE DATE</h3>
      
                <h3 className="section"   style={{
                  color:"#999999"
                }}>PAYMENT DATE</h3>
      
                <h3 className="section"  style={{
                  color:"#999999"
                }}>STATUS</h3>
              </div>
            </td>
          </tr>
      
          
          <tr className="details-row values-row">
            <td colSpan="9">
              <div className="order-details-box values" style={{backgroundColor:"#f7f9fb"}}>
                <h3 className="section">#1456</h3>
                <h3 className="section">EGP990</h3>
                <h3 className="section">Bank tranfer</h3>
                <h3 className="section">.....998</h3>
                <h3 className="section">24 may 2025</h3>
                <h3 className="section">12:00 PM</h3>
                <h3 className="section">Complete</h3>

                
              </div>
            </td>

            
          </tr>
              
          <tr className="details-row values-row">
            <td colSpan="9">
              <div className="order-details-box values" style={{backgroundColor:"#f7f9fb",  color:"#666666",fontSize:"20px"}}>
              

            <h3 className="section"></h3>
                <h3 className="section"></h3>
                <h3 className="section"></h3>
                <h3 className="section"></h3>
                <h3 className="section"></h3>
                     <h3 className="section" style={{backgroundColor:"#f7f9fb",  color:"#666666",cursor:"pointer"}}> <PiShareFatLight style={{fontSize:"20px"}}/>Share</h3>
                <h3 className="section" style={{backgroundColor:"#f7f9fb",  color:"#666666",cursor:"pointer"}}><BiSolidPrinter style={{fontSize:"20px"}}/> Print</h3>
                
              </div>
            </td>

            
          </tr>
        </>
          
        </>
        
      )}
      
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
    </div>
  )
}
